/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_f1_profile_tooltip_result_dist_constructor = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Combined result types across both drivers for the season`)
};

const es_f1_profile_tooltip_result_dist_constructor = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tipos de resultado combinados de ambos pilotos en la temporada`)
};

const de_f1_profile_tooltip_result_dist_constructor = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kombinierte Ergebnistypen beider Fahrer für die Saison`)
};

const nl_f1_profile_tooltip_result_dist_constructor = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gecombineerde resultaattypen van beide coureurs voor het seizoen`)
};

const fr_f1_profile_tooltip_result_dist_constructor = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Types de résultats combinés des deux pilotes pour la saison`)
};

const it_f1_profile_tooltip_result_dist_constructor = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tipi di risultato combinati di entrambi i piloti per la stagione`)
};

const pt_br2_f1_profile_tooltip_result_dist_constructor = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tipos de resultados combinados de ambos os pilotos na temporada`)
};

const pt_f1_profile_tooltip_result_dist_constructor = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tipos de resultado combinados de ambos os pilotos na época`)
};

const ja_f1_profile_tooltip_result_dist_constructor = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`シーズンを通じた両ドライバーの合算結果タイプ`)
};

const zh_f1_profile_tooltip_result_dist_constructor = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`两位车手整个赛季的合计成绩类型`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const f1_profile_tooltip_result_dist_constructor = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.f1_profile_tooltip_result_dist_constructor(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("f1_profile_tooltip_result_dist_constructor", locale)
	if (locale === "en") return en_f1_profile_tooltip_result_dist_constructor(inputs)
	if (locale === "es") return es_f1_profile_tooltip_result_dist_constructor(inputs)
	if (locale === "de") return de_f1_profile_tooltip_result_dist_constructor(inputs)
	if (locale === "nl") return nl_f1_profile_tooltip_result_dist_constructor(inputs)
	if (locale === "fr") return fr_f1_profile_tooltip_result_dist_constructor(inputs)
	if (locale === "it") return it_f1_profile_tooltip_result_dist_constructor(inputs)
	if (locale === "pt-BR") return pt_br2_f1_profile_tooltip_result_dist_constructor(inputs)
	if (locale === "pt") return pt_f1_profile_tooltip_result_dist_constructor(inputs)
	if (locale === "ja") return ja_f1_profile_tooltip_result_dist_constructor(inputs)
	return zh_f1_profile_tooltip_result_dist_constructor(inputs)
};